import { translate } from '../i18n/translations';
import { readStoredLanguage } from '../i18n/LanguageContext';

/** Resolve UI language from user prefs or localStorage. */
export function expenseLang(user) {
  const pref = user?.preferences?.language;
  if (pref === 'sw' || pref === 'en') return pref;
  const stored = readStoredLanguage(user?.id);
  if (stored === 'sw' || stored === 'en') return stored;
  return 'en';
}

export function expT(lang, key, vars) {
  return translate(lang, key, vars);
}
